// utils/sentry.ts
import * as Sentry from '@sentry/react';

export const captureError = (error: unknown) => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (import.meta.env.PROD && dsn) {
    Sentry.captureException(error);
  } else {
    console.error('Dev error log:', error);
  }
};
